// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2SreS","consentsList":"PatientConsents_consentsList__3tKqi","consentsListEmpty":"PatientConsents_consentsListEmpty__1A01O"};